export default __webpack_public_path__ + "static/later-board-1a70d7ff8eb63b4f49c5957aa3c6719c.webp";